export default __webpack_public_path__ + "static/media/space_design.ed85c6a4.jpg";